"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeColors = void 0;
const totangoGreenColor = {
    totangoGreen100: '#26DB93',
    totangoGreen200: '#048254',
    totangoGreen300: '#05A168',
    totangoGreen400: '#04754C',
    totangoGreen500: '#EFFFF9',
    totangoGreen600: '#D3F9EA',
    totangoGreen700: '#25DB93',
    totangoGreen800: '#FAFCF9',
    totangoGreen900: '#F5FFEC',
};
exports.themeColors = {
    whiteColor: '#FFFFFF',
    blackColor: '#000000',
    primaryColor: totangoGreenColor.totangoGreen300,
    secondaryColor: '#5DACD2',
    borderColor: '#dddddd',
    mainColor: '#282828',
    errorColor: '#C0392B',
    warningColor: '#F4C430',
    disabledBG: '#e6e5e578',
    goodHealthColor: '#26B27F',
    lightGoodHealthColor: '#05A1684D',
    averageHealthColor: '#F7C900',
    lightAverageHealthColor: '#F7C9004D',
    poorHealthColor: '#C23824',
    lightPoorHealthColor: '#C0392B4D',
    loadingIndicatorColor: '#c3c3c3',
    lightGrayBorder: '#D8D8D8',
    mentionBorderColor: '#E7E7E7',
    mentionPersonColor: '#5DACD2',
    linkColor: '#5DACD2',
    goodHealthHalo: '#A9E0CC',
    averageHealthHalo: '#FBE99B',
    poorHealthHalo: '#E6B0A9',
    labelColor: '#706c5e',
    totangoBlack: '#282828',
    unknownHealthColor: '#8fcaef',
    vikingColor: '#4AC6DE',
    cannonPinkColor: '#893D70',
    blueShakespeare: '#5EACD2',
    blumineColor: '#186181',
    indigoColor: '#5372CE',
    bisqueTagColor: '#FFF7E7',
    greenTagColor: '#24EC9D33',
    totangoGray500: '#757575',
    totangoGray300: '#d8d8d8',
    totangoGray200: '#eeeeee',
    totangoGray100: '#f5f5f5',
    grayGallery: '#F0F0F0',
    grayDusty: '#979797',
    totangoGreen: totangoGreenColor.totangoGreen300,
    totangoGreen100: totangoGreenColor.totangoGreen100,
    totangoGreen200: totangoGreenColor.totangoGreen200,
    totangoGreen500: totangoGreenColor.totangoGreen500,
    totangoTextBtnHover: 'rgba(38, 219, 147, .2)',
    totangoRed: '#EF3D4E',
    totangoPurple: '#5016BD',
    campaignStats: {
        deliveredColor: '#e1f5f5',
        deliveredMainColor: '#6dcfcb',
        viewedColor: '#e7f7e6',
        viewedMainColor: '#8ed281',
        engagedColor: '#f9e1ea',
        engagedMainColor: '#e36c96',
        goalColor: '#e4e0f0',
        goalMainColor: '#716ab6',
        goalBgColor: '#5F478A',
    },
    automationActions: {
        updateAttribute: '#476ADB',
    },
    attentionOrange: '#F06630',
    attentionGray: '#444444',
    selectionPanelPrimaryColor: '#40AC90',
    userFilterLabelIconColor: '#773CAB',
    // NEW COLORS
    totangoError600: '#FF7658',
    totangoPrimaryYellow: '#F6C14F',
    totangoGray300Shades: '#ACB0B4',
    totangoGray400Shades: '#969A9E',
    totangoGreen600Shades: '#07C07D',
};
//# sourceMappingURL=themeColors.js.map